import { render, staticRenderFns } from "./declareReturn.vue?vue&type=template&id=7efdb958&"
import script from "./declareReturn.vue?vue&type=script&lang=js&"
export * from "./declareReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports